module.exports = __webpack_public_path__ + "img/798.2e765c69.gif";